export const skillCategories = [
  {
    title: 'Languages',
    items: ['TypeScript', 'JavaScript', 'Python', 'Java', 'C', 'C++', 'SQL'],
  },
  {
    title: 'Backend',
    items: ['Node.js', 'Express', 'Next.js API', 'PostgreSQL', 'Prisma', 'Redis', 'MongoDB', 'Firebase'],
  },
  {
    title: 'Frontend',
    items: ['React', 'Next.js', 'Tailwind CSS', 'Framer Motion'],
  },
  {
    title: 'Systems & Architecture',
    items: ['Distributed Systems', 'Event-Driven Architecture', 'Microservices', 'System Design', 'Caching', 'Rate Limiting', 'Queues (Kafka concepts)'],
  },
  {
    title: 'DevOps & Cloud',
    items: ['Docker', 'GitHub Actions', 'Vercel', 'AWS (EC2, S3)', 'Azure', 'Neon PostgreSQL'],
  },
  {
    title: 'Integrations',
    items: ['Stripe', 'Firebase Auth', 'NextAuth.js', 'Gemini AI', 'OpenAI', 'ElevenLabs'],
  },
  {
    title: 'Tools',
    items: ['Postman', 'Git', 'WebSockets', 'gRPC (concepts)'],
  },
];

